module.exports = __webpack_public_path__ + "images/assets/6459bad38a6f453c015b6be2b8b1b623.svg";